import { toast } from "sonner";
import { Upload, X } from "lucide-react";
import { MAX_IMAGE_SIZE_BYTES } from "./articleUtils";

export const ImageUploader = ({ value, onChange }) => {
  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      toast.error(`Image must be under ${Math.round(MAX_IMAGE_SIZE_BYTES / 1024 / 1024)}MB`);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div className="flex items-start gap-4">
      <label className="wofy-btn-ghost cursor-pointer" data-testid="upload-image-btn">
        <Upload className="w-4 h-4" /> Upload
        <input type="file" accept="image/*" className="hidden" onChange={handleFile} />
      </label>
      {value && (
        <div className="relative">
          <img src={value} alt="preview" className="h-24 w-40 object-cover rounded-xl" />
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow"
            aria-label="Remove image"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      )}
    </div>
  );
};
